import {motion} from 'framer-motion';

function Marquee({items}) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-ink/10 bg-bone py-6" aria-hidden="true">
      <motion.div
        className="flex w-max items-center gap-10 whitespace-nowrap"
        animate={{x: ['0%', '-50%']}}
        transition={{duration: 40, ease: 'linear', repeat: Infinity}}
      >
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="h-display text-4xl md:text-6xl">{t}</span>
            <span className="text-2xl text-brick">✦</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}

export default Marquee;
